import { HttpResult } from 'widgets-for-react'
import { filtersToQueryParams, NewsAndEventsFilters } from '../../utils/filtersToQueryParams'
import {
  NewsOrEventData,
  transformNewsOrEventData,
} from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockApi'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'

export const newsAndEventsOverviewApi = async (
  filters: NewsAndEventsFilters,
  page: number
): Promise<HttpResult<NewsOrEvent[]>> => {
  
  const shouldContainExcludedTags = (filters.tags?.includes("Hoor Floor") || filters.tags?.includes("Inspiratie")) ? true : false
  const res = await fetch(`/api/v1/pages/newsandevents/filter?${filtersToQueryParams(filters)}&page=${page - 1}&shouldContainExcludedTags=${shouldContainExcludedTags}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  document.title = 'Nieuws en evenementen | Spaarne Gasthuis'

  const data: NewsOrEventData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: transformNewsOrEventData(data),
  }
}
